import { differenceInCalendarDays } from 'date-fns'

// "hoje", "há 1 dia", "há 4 dias"
export const formatDaysAgo = (date?: string) => {
  if (!date) return ''
  const days = differenceInCalendarDays(new Date(), new Date(date))
  if (days <= 0) return 'hoje'
  return `há ${days} ${days === 1 ? 'dia' : 'dias'}`
}
